import portafolioImg1 from './IMG/img1.webp';
import portafolioImg2 from './IMG/img2.webp';
import portafolioImg3 from './IMG/DISENOPORTARROLLOS.webp';
import portafolioImg4 from './IMG/DISENOPRENSAMOTOR.webp';
import portafolioImg5 from './IMG/IMPRESION3D.webp';
import portafolioImg6 from './IMG/IMPRESION3D2.webp';
import portafolioImg7 from './IMG/MAQUINADOINDPORTARROLLOS.webp';
import portafolioImg8 from './IMG/MAQUINADOINDPRENSAS.webp';
import portafolioImg9 from './IMG/SOLDADURABRACKETS.webp';
import portafolioImg10 from './IMG/SOLDADURAMUEBLE.webp';
import portafolioImg11 from './IMG/SOLUCIONESDISPENSADOR.webp';
import portafolioImg12 from './IMG/SOLUCIONESCARRITO.webp';
import portafolioImg13 from './IMG/SOLUCIONESGUARDAS1.webp';

export const portImg1 = portafolioImg1;
export const portImg2 = portafolioImg2;
export const portImg3 = portafolioImg3;
export const portImg4 = portafolioImg4;
export const portImg5 = portafolioImg5;
export const portImg6 = portafolioImg6;
export const portImg7 = portafolioImg7;
export const portImg8 = portafolioImg8;
export const portImg9 = portafolioImg9;
export const portImg10 = portafolioImg10;
export const portImg11 = portafolioImg11;
export const portImg12 = portafolioImg12;
export const portImg13 = portafolioImg13;
